module.exports = __webpack_public_path__ + "static/img/3Seats.e4db332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seats/3Seats.png
// module id = 1089
// module chunks = 0 3